import React from 'react';
import { DropTarget } from 'react-dnd';
import flow from 'lodash.flow';
import Row from './Row';
import Highlightable from '../HOCs/Highlightable';
import { ItemTypes } from '../constants';
import { connect } from 'react-redux';

import {
  insertRow
} from '../actions/container-actions';

import styles from '../../../../stylesheet/css/header-builder/grid.css';

const target = {
  drop(props, monitor) {
    const row = monitor.getItem();
    const { device, onInsertRow } = props;

    onInsertRow(device, row);
  }
};

const collect = (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver()
  };
};

let Grid = ({
  id,
  rows,
  category,
  active,
  device,
  className,
  isHighlighted,
  onHighlight,
  connectDropTarget,
  canDrop,
  isOver,
  options = {}
}) => {
  let cl = className + (active ? ' ' + styles.active : '');

  if (canDrop && isOver) {
    cl += ' ' + styles.canDrop;
  }

  return connectDropTarget(
    <div className={cl} onClick={onHighlight}>
      {rows.map((row, index) => <Row key={row.id} device={device} {...row} />)}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.model[ownProps.device].present,
    active: state.model.activeDevice === ownProps.device,
    model: state.model[ownProps.device].present,
    className: styles.editor
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onInsertRow(device, row) {
      dispatch(insertRow({ device, row }));
    }
  };
};

Grid = flow(
  Highlightable(),
  DropTarget(ItemTypes.ROW, target, collect)
)(Grid);

export { Grid };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Grid);



// WEBPACK FOOTER //
// ./app/header-builder/components/Grid.js